/** Derived collection risk tier for UC-O0 filters (v1 ExecutiveDashboard getClientRiskLevel). */

export type ClientRiskLevel = 'Critical' | 'High' | 'Medium' | 'Low' | 'No Risk'

export function getClientRiskLevel(client: Record<string, unknown>): ClientRiskLevel {
	const overdueCount =
		Number(client.overdue_invoice_count) || Number(client.overdue_invoices) || 0
	const paymentRate = Number(client.payment_rate) || 0

	if (overdueCount > 0 && paymentRate < 50) return 'Critical'
	if (overdueCount > 0 && paymentRate < 70) return 'High'
	if (overdueCount > 0 && paymentRate < 90) return 'Medium'
	if (overdueCount > 0) return 'Low'
	return 'No Risk'
}
